module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "prevArrow.4f4db298.svg";